export function header() {
    let win = window;
    let $body = $("body");
    let activeClass = "active";
    let openClass = "open";
    let showMenuClass = "show-menu";
    let openMenuName = "open-menu";
    let navBtnName = "menu-item-button";
    let durationDefault = 400;
    let navDropBtn = $("." + navBtnName + ", .menu-button");
    let dropHolder = $(".nav-dropdown-content");
    let dropWrapper = $(".header-wrapper");
    let getIsDesktop = function () {
        return win.innerWidth >= 1200;
    };
    let openTarget = null;

    function addTarget($target) {
        const isSearch = $target.hasClass("search-link");
        openTarget = {
            $btn: $target,
            $item: isSearch ? $target.closest(".header-holder") : $target.parent(),
            $dropdown: isSearch ? $target.closest(".header-holder").find(".search-dropdown").eq(0) : $target.parent().find(".dropdown").eq(0)
        };
    }

    function removeTarget() {
        openTarget = null;
    }

    function toggleDropdown(isOpen) {// show by default
        let duration = durationDefault;

        openTarget.$item[`${isOpen ? "remove" : "add"}Class`](openClass);
        openTarget.$item.parent()[`${isOpen ? "remove" : "add"}Class`](openClass + "ed");

        if (!isOpen) {
            openTarget.$dropdown.css("visibility", "visible");
            if(getIsDesktop()) {
                openTarget.$dropdown.css("top", $(".header").innerHeight());
            } else {
                if (!openTarget.$item.hasClass("nav-dropdown-col")) {
                    openTarget.$item.siblings().addClass("no-active");
                }
            }
        }
        openTarget.$dropdown[`slide${isOpen ? "Up" : "Down"}`](duration, function () {
            if (isOpen) {
                $(this).css("visibility", "hidden");

                if(getIsDesktop()) {
                    $(this).css("top", "auto");
                } else {
                    if ($(".header").find(":not(.nav-dropdown-col).open").length === 0) {
                        $(".header").find(".no-active").removeClass("no-active");
                    }
                }
            }
        });

        // openTarget.$btn.attr(expandedAttr, !isOpen);
    }

    $body.on("click", function (e) {
        let target = e.target;
        let $target = $(target);
        let isOpenMobileMenuBtn = $target.hasClass(openMenuName);
        let isNavBtn = ($target.hasClass(navBtnName) || $target.hasClass(navBtnName + "-arrow")) && $target.closest("li").find(".dropdown").length > 0;
        let isHeaderLinkBtn = $target.hasClass("header-link");

        if (isOpenMobileMenuBtn || isNavBtn || isHeaderLinkBtn) {
            e.preventDefault();
        }

        if (isOpenMobileMenuBtn) {  //toggle mobile menu
            $body.toggleClass(showMenuClass);
            $body.removeClass("show-search");
        } else if($target.hasClass("search-link") && !getIsDesktop()) {
            $body.removeClass(showMenuClass);
            $body.toggleClass("show-search");

        } else if (isNavBtn || isHeaderLinkBtn) {  //toggle nav (main) menu dropdowns
            if (openTarget === null) {
                addTarget($target);
                toggleDropdown(); //show
            } else {
                if ($target.parent().hasClass("open") || ($target.hasClass("search-link") && $target.closest(".header-holder").hasClass("open"))) {
                    addTarget($target);
                    toggleDropdown(true); //hide
                    removeTarget();
                } else {
                    if (getIsDesktop()) {
                        toggleDropdown(true); //hide old
                    }
                    addTarget($target);
                    toggleDropdown(); //show new
                }
            }
        } else if (openTarget !== null) {
            let openTargetIsNavBtn = openTarget.$btn.hasClass(navBtnName);
            let isHideDropdown = !(openTargetIsNavBtn && !getIsDesktop());

            if (isHideDropdown) {
                if (!($target.closest(openTarget.$item)).length) {
                    toggleDropdown(true); //hide
                    removeTarget();
                }
            }
        }
    });

    navDropBtn.hover(function (e){
        $(e.target).addClass("active-state");

        if ($(e.target).closest(".nav-dropdown-content").length) {
            dropHolder.addClass("hover-active");
        }

        if($(e.target).closest(".nav").length) {
            $(".nav").addClass("hover-active");
        }
    }, function (){
        dropHolder.removeClass("hover-active");
        navDropBtn.removeClass("active-state");
        $(".nav").removeClass("hover-active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js